/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GenerateStripeIntentResponse,
  GetAddCreditCardAuthorizationIdResponse,
  GetAllPaymentMethodsResponse,
  OnPaymentMethodAddedRequest,
  PayInvoicesRequest,
  PayInvoicesResponse,
  RemovePaymentMethodRequest,
  SetDefaultPaymentMethodRequest,
  VerifyMicrodepositsRequest,
  VerifyMicrodepositsResponse,
} from '../models/index';
import {
    GenerateStripeIntentResponseFromJSON,
    GenerateStripeIntentResponseToJSON,
    GetAddCreditCardAuthorizationIdResponseFromJSON,
    GetAddCreditCardAuthorizationIdResponseToJSON,
    GetAllPaymentMethodsResponseFromJSON,
    GetAllPaymentMethodsResponseToJSON,
    OnPaymentMethodAddedRequestFromJSON,
    OnPaymentMethodAddedRequestToJSON,
    PayInvoicesRequestFromJSON,
    PayInvoicesRequestToJSON,
    PayInvoicesResponseFromJSON,
    PayInvoicesResponseToJSON,
    RemovePaymentMethodRequestFromJSON,
    RemovePaymentMethodRequestToJSON,
    SetDefaultPaymentMethodRequestFromJSON,
    SetDefaultPaymentMethodRequestToJSON,
    VerifyMicrodepositsRequestFromJSON,
    VerifyMicrodepositsRequestToJSON,
    VerifyMicrodepositsResponseFromJSON,
    VerifyMicrodepositsResponseToJSON,
} from '../models/index';

export interface OnPaymentMethodAddedOperationRequest {
    onPaymentMethodAddedRequest?: OnPaymentMethodAddedRequest;
}

export interface PayInvoicesOperationRequest {
    payInvoicesRequest?: PayInvoicesRequest;
}

export interface RemovePaymentMethodOperationRequest {
    removePaymentMethodRequest?: RemovePaymentMethodRequest;
}

export interface SetDefaultPaymentMethodOperationRequest {
    setDefaultPaymentMethodRequest?: SetDefaultPaymentMethodRequest;
}

export interface SwapAddCreditCardAuthorizationIdForSaveCardIntentRequest {
    addCreditCardAuthorizationId: string;
}

export interface VerifyMicrodepositsOperationRequest {
    verifyMicrodepositsRequest?: VerifyMicrodepositsRequest;
}

/**
 * 
 */
export class PaymentMethodsApi extends runtime.BaseAPI {

    /**
     * 
     * 
     */
    async generateSaveBankAccountIntentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateStripeIntentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment-methods/generate-save-bank-account-intent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateStripeIntentResponseFromJSON(jsonValue));
    }

    /**
     * 
     * 
     */
    async generateSaveBankAccountIntent(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateStripeIntentResponse> {
        const response = await this.generateSaveBankAccountIntentRaw(initOverrides);
        return await response.value();
    }

    /**
     * Generates an intent that be used to securely store credit card information
     * Generate Save Card Intent
     */
    async generateSaveCardIntentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateStripeIntentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment-methods/generate-save-card-intent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateStripeIntentResponseFromJSON(jsonValue));
    }

    /**
     * Generates an intent that be used to securely store credit card information
     * Generate Save Card Intent
     */
    async generateSaveCardIntent(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateStripeIntentResponse> {
        const response = await this.generateSaveCardIntentRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gives an authenticated user access to the company\'s Add Credit Card Authorization Id. They can then construct a URL containing this token which can be sent to someone who does not have an account. Then that user can swap the token for a save card intent to add their credit card.
     * Your GET endpoint
     */
    async getAddCreditCardAuthorizationIdRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAddCreditCardAuthorizationIdResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment-methods/get-add-credit-card-authorization-id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAddCreditCardAuthorizationIdResponseFromJSON(jsonValue));
    }

    /**
     * Gives an authenticated user access to the company\'s Add Credit Card Authorization Id. They can then construct a URL containing this token which can be sent to someone who does not have an account. Then that user can swap the token for a save card intent to add their credit card.
     * Your GET endpoint
     */
    async getAddCreditCardAuthorizationId(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAddCreditCardAuthorizationIdResponse> {
        const response = await this.getAddCreditCardAuthorizationIdRaw(initOverrides);
        return await response.value();
    }

    /**
     * Your GET endpoint
     */
    async getAllPaymentMethodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllPaymentMethodsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment-methods/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllPaymentMethodsResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async getAllPaymentMethods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllPaymentMethodsResponse> {
        const response = await this.getAllPaymentMethodsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async onPaymentMethodAddedRaw(requestParameters: OnPaymentMethodAddedOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment-methods/on-payment-method-added`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OnPaymentMethodAddedRequestToJSON(requestParameters['onPaymentMethodAddedRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async onPaymentMethodAdded(requestParameters: OnPaymentMethodAddedOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.onPaymentMethodAddedRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async payInvoicesRaw(requestParameters: PayInvoicesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PayInvoicesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment-methods/pay-invoices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PayInvoicesRequestToJSON(requestParameters['payInvoicesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PayInvoicesResponseFromJSON(jsonValue));
    }

    /**
     * 
     */
    async payInvoices(requestParameters: PayInvoicesOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PayInvoicesResponse> {
        const response = await this.payInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async removePaymentMethodRaw(requestParameters: RemovePaymentMethodOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment-methods/remove`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RemovePaymentMethodRequestToJSON(requestParameters['removePaymentMethodRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async removePaymentMethod(requestParameters: RemovePaymentMethodOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePaymentMethodRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async setDefaultPaymentMethodRaw(requestParameters: SetDefaultPaymentMethodOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment-methods/set-default-payment-method`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetDefaultPaymentMethodRequestToJSON(requestParameters['setDefaultPaymentMethodRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async setDefaultPaymentMethod(requestParameters: SetDefaultPaymentMethodOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setDefaultPaymentMethodRaw(requestParameters, initOverrides);
    }

    /**
     * Your GET endpoint
     */
    async swapAddCreditCardAuthorizationIdForSaveCardIntentRaw(requestParameters: SwapAddCreditCardAuthorizationIdForSaveCardIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateStripeIntentResponse>> {
        if (requestParameters['addCreditCardAuthorizationId'] == null) {
            throw new runtime.RequiredError(
                'addCreditCardAuthorizationId',
                'Required parameter "addCreditCardAuthorizationId" was null or undefined when calling swapAddCreditCardAuthorizationIdForSaveCardIntent().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['addCreditCardAuthorizationId'] != null) {
            queryParameters['addCreditCardAuthorizationId'] = requestParameters['addCreditCardAuthorizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payment-methods/swap-add-credit-card-authorization-id-for-save-card-intent`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateStripeIntentResponseFromJSON(jsonValue));
    }

    /**
     * Your GET endpoint
     */
    async swapAddCreditCardAuthorizationIdForSaveCardIntent(requestParameters: SwapAddCreditCardAuthorizationIdForSaveCardIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateStripeIntentResponse> {
        const response = await this.swapAddCreditCardAuthorizationIdForSaveCardIntentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm a pending ACSS Debit bank account by submitting the two micro-deposit amounts Stripe sent to the customer\'s bank.
     * 
     */
    async verifyMicrodepositsRaw(requestParameters: VerifyMicrodepositsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyMicrodepositsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/payment-methods/verify-microdeposits`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyMicrodepositsRequestToJSON(requestParameters['verifyMicrodepositsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyMicrodepositsResponseFromJSON(jsonValue));
    }

    /**
     * Confirm a pending ACSS Debit bank account by submitting the two micro-deposit amounts Stripe sent to the customer\'s bank.
     * 
     */
    async verifyMicrodeposits(requestParameters: VerifyMicrodepositsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyMicrodepositsResponse> {
        const response = await this.verifyMicrodepositsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
